var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1251 31.7907C65.8803 34.4602 67.0352 37.6335 69.7048 38.8783C72.3743 40.1231 75.5476 38.9682 76.7924 36.2986C78.0372 33.6291 76.8823 30.4558 74.2127 29.211C71.5432 27.9662 68.3699 29.1212 67.1251 31.7907ZM0.577382 1.86236L71.5361 34.951L72.3814 33.1384L1.42262 0.0497469L0.577382 1.86236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLine1);
export default __webpack_public_path__ + "static/media/bottomLine1.59ad87b59569e6b501703c0154c6bc6c.svg";
export { ForwardRef as ReactComponent };